import { html, LitElement, css, unsafeCSS } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import { isSunforge, isTouchDevice } from '../shared/utils';

import '../components/discorduser';

import style from './decklist.scss';

export class DeckListComponent extends LitElement {

    static get properties() {
        return {
            data: Array,
            title: String,
            url: String,
            showduration: Boolean,
            autohide: Boolean,
            showpoints: Boolean,
            diff: String 
        }
     }

    constructor() {
        super();
        this.data = null;
        this.url = '';
        this.showduration = false;
        this.title = 'Recent Decks';
        this.autohide = false;
        this.showpoints = false;
        this.diff = '';
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();        
        this.fetchData();
    }

    async fetchData() {                        
        let res = await fetch(`./api/${this.url}${this.diff?`?diff=${this.diff}`:''}`);
        this.data = await res.json();        
    }
   
    render() {
        if(this.autohide && this.data?.length === 0)
            return html``;          
        return html`     
            <h3 class="title">${this.title}${this.url.startsWith('user')?` (${this.data?.length||0})`:''}</h3>      
            <div class="decks">       
            ${this.data === null ? html`
                ${[1,2,3,4,5].map(i=>html`
                    <div class="line">
                        ${!isTouchDevice()?html`<div class="loader icon"></div> `:''}<div class="loader${i>1?' small':''}"></div>
                    </div>
                `)}                
            `:html`
            ${this.data.length === 100 ? html`Note: Only the top 100 runs are shown.`:''}
            `}     
            ${this.data?.map(deck=>{
                let artwork = 'cardart_5_50';
                if (deck.talents[0]?.artwork)
                    artwork = deck.talents[0].artwork;
                if (deck.base[1]?.artwork)
                    artwork = deck.base[1].artwork;
                return html`<div class="line">
                    <a class="class-${deck.subclass?.toLowerCase()||deck.class.replace('[','').replace(']','').toLowerCase()}" href="./deck/${deck.uid}"><div class="artwork" 
                    style="background-image:url(./images/icons/${(artwork||'').replace(/ /g,'%20')}.webp);${isTouchDevice()?`position: absolute;
    right: 10px;`:''}"></div> ${deck.name}${isTouchDevice()?html`<br/>`:' '}${isSunforge(deck.class) ? deck.subclass||'Sunforge' : deck.class} ${isSunforge(deck.class) ? `[${Math.round(deck.bosses.length/32*100)}% complete]` : deck.diff}</a>                     
                    ${deck.discorduser&&!this.url.startsWith('user')?html`          
                    ${isTouchDevice()?html`<br>`:html`&nbsp;&nbsp;`}                              
                    <discorduser-component user=${deck.discorduser}></discorduser-component>
                    `:''}
                    <div style=${styleMap(!isTouchDevice()?{
                        'position':'absolute',
                        'right':'10px',
                        'top': '15px',
                        'text-align':'right',
                        'font-weight':'bold'                        
                    }:{
                        'margin-top':'5px'
                    })}>     
                        ${deck.challenge && !this.showpoints ? html` ⚔️ `:''}                   
                        ${(this.showduration || isSunforge(deck.class)) && !this.showpoints ? html`
                            ${(deck.stats.clock1||'').replace(/\*/g,'').replace('Duration:','🕐')}
                        `: html`
                            ${this.showpoints ? html`
                                ${(deck.stats.trophy||'').replace(/\*/g,'')}${deck.bonus?html` <span class="bubble" style="color:${deck.bonus>0?'lightgreen':'#ffcccc'};">${deck.bonus>0?'+':''}${deck.bonus}</span>`:''}
                            `:html`
                            🎲 <a href="./seed/${deck.seed}" style="${deck.slain && !isSunforge(deck.class)?'color:red':''}">${deck.seed}</a>
                            `}                            
                        `}                                                                        
                    </div>                    
                </div>`;
            })}    
            </div>
        `;
    }
}

customElements.define('decklist-component', DeckListComponent);